import { cx } from '@emotion/css';
import { CSSProperties, lazy, ReactNode, Suspense } from 'react';
import { Skeleton } from '../../src/components/ui/skeleton';
import type { ShadcnErrorFallbackInstance } from './ShadcnErrorFallback';

const ShadcnErrorBoundary = lazy(() => import('./ShadcnErrorBoundary'));

export const ShadcnSkeleton = ({
    children,
    override,
    error,
    fallbackStyle,
    id,
    root,
    fallbackClassName,
}: {
    children?: ReactNode;
    style?: CSSProperties;
    spin?: ReactNode;
    fallbackClassName?: string;
    fallbackStyle?: CSSProperties;
    error?: ShadcnErrorFallbackInstance;
    override?: {
        loading?: boolean;
        error?: ShadcnErrorFallbackInstance;
    };
    id?: string;
    root?: boolean;
}) => {
    const child = (
        <ShadcnErrorBoundary
            error={root ? { status: 500, ...error } : error}
            id={id}
            overide={override?.error}
        >
            {children}
        </ShadcnErrorBoundary>
    );

    const classNames: string[] = [];
    if (root) classNames.push('shadcn-root-fallback');
    else classNames.push('shadcn-fallback');

    const fallback = (
        <>
            <Skeleton
                className={cx('h-9 w-full', fallbackClassName)}
                style={fallbackStyle}
            />
        </>
    );

    if (override?.loading) return fallback;

    return <Suspense fallback={fallback}>{child}</Suspense>;
};
